import { Env } from '../contexts/AppContext';

interface ImgixSrcParamsEnvDependent {
  path: string;
  isEnvDependent: true;
  envContext: Env;
}

interface ImgixSrcParamsGlobal {
  path: string;
  isEnvDependent: false;
  envContext?: Env;
}

type getImgixSrcParams = ImgixSrcParamsGlobal | ImgixSrcParamsEnvDependent;

const IMGIX_URL = 'https://tii.imgix.net';

export const getImgixSrc = ({ path, isEnvDependent, envContext }: getImgixSrcParams) => {
  const env = isEnvDependent ? envContext?.IMGIX_ENV : 'global';
  return `${IMGIX_URL}/${env}/${path}`;
};

export const getArticleImgSrc = (id: number, picture: string, env: Env) => {
  if (!picture) {
    return getImgixSrc({
      path: 'articles/article_default_rebrand.jpg',
      isEnvDependent: true,
      envContext: env,
    });
  }

  return getImgixSrc({
    path: `articles/${id}/${picture}`,
    isEnvDependent: true,
    envContext: env,
  });
};
